//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  mapState,
  mapMutations
} from 'vuex'
import {
  orderDetail,
  cancelOrder
} from '../../service/index'
import Api from '../../utils/config'

export default {
  data() {
    return {
      orderDetail: {},
      orderGoodsList: [],
      payment: Api.payment,
      paymentMb: Api.paymentMb,
      dialogVisible: false,
      activeName: '1',
      showSuccessInfo: false
    }
  },
  created() {
    const orderId = this.$route.params.orderId
    this.getOrderDetail(orderId)
    this.keepLang()
    if (this.$route.query.showSuccess === "true") {
      this.showSuccessInfo = true;
    }
  },
  computed: {
    ...mapState(['global']),
    invalidGoodList() {
      if (this.orderDetail.lackItems) {
        return JSON.parse(this.orderDetail.lackItems.replace("\\", ""))
      }
    }
  },
  methods: {
    showDialog() {
      this.dialogVisible = true
    },
    async getOrderDetail(orderId) {
      const res = await orderDetail(orderId)
      if (res.status === 0) {
        this.orderDetail = res.data
        this.orderGoodsList = res.data.items
      }
    },
    payMoney(orderId) {
      // this.$router.push({path: '/pay/' + orderId})
      window.location = Api.payment + orderId
    },
    keepLang() {
      let locale = localStorage.locale;
      this.$i18n.locale = locale === 'en' ? locale : 'zh';
    },
    async cancel(orderId) {
      const res = await cancelOrder(orderId)
      if (res.status === 0) {
        this.dialogVisible = false
        this.$message({

          message: this.$t('order.cancelSuccess'),
          type: 'success'
        })
        this.orderDetail.status = 12
      } else {
        this.$message({
          message: this.$t('order.cancelFailed'),
          type: 'error'
        })
      }
    },
    exportDetail(orderId) {
      window.location.href = "/is/store/order/exportDetail/" + orderId;
    }
  }
}




// WEBPACK FOOTER //
// ./src/components/order/OrderDetail.vue